import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconSpa(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-spa_svg__filled",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("path", {
        d: "M30.68,16a31.8,31.8,0,0,0-3.84-5.58l-.1-.11h0a1,1,0,0,0-1.47,0h0l-.1.11A31.35,31.35,0,0,0,21.32,16,25.49,25.49,0,0,0,18,28c0,9.89,7.23,13.73,7.54,13.89l.21.1.25.14.26-.14.2-.1c.31-.16,7.54-4,7.54-13.89A25.49,25.49,0,0,0,30.68,16Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M48,22.09a2.28,2.28,0,0,0,0,.26C48,22.2,48,22.11,48,22.09Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M48,22.08s0-.09,0-.14,0,.09,0,.14Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M46.93,21h0Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M38.9,12.56A1,1,0,0,0,37.76,12a18,18,0,0,0-5.49,2.76,30.85,30.85,0,0,1,2.83,6.87,22.78,22.78,0,0,1,5.18-1.8A17.77,17.77,0,0,0,38.9,12.56Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M35.57,23.67A23.35,23.35,0,0,1,36,28,17.81,17.81,0,0,1,30.08,41.7a20,20,0,0,0,12.49-6.52,21.11,21.11,0,0,0,2.14-3A25.63,25.63,0,0,0,48,22.35a2.28,2.28,0,0,1,0-.26h0s0-.09,0-.14a1,1,0,0,0-.25-.6A1,1,0,0,0,47,21h-.11C45.05,21.08,39.68,21.43,35.57,23.67Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M48,21.94a1,1,0,0,0-.25-.6A1,1,0,0,0,47,21a1,1,0,0,1,.73.31A1,1,0,0,1,48,21.94Z"
      }), /*#__PURE__*/React.createElement("polygon", {
        points: "48 22.08 48 22.08 48 22.09 48 22.08"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M42.57,35.18A22.34,22.34,0,0,0,48,22.35a25.63,25.63,0,0,1-3.27,9.85A21.11,21.11,0,0,1,42.57,35.18Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M4,22.09a2.28,2.28,0,0,1,0,.26C4,22.2,4,22.11,4,22.09Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M4,22.08s0-.09,0-.14,0,.09,0,.14Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M5.07,21h0Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M13.1,12.56A1,1,0,0,1,14.24,12a18,18,0,0,1,5.49,2.76,30.85,30.85,0,0,0-2.83,6.87,22.78,22.78,0,0,0-5.18-1.8A17.77,17.77,0,0,1,13.1,12.56Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M16.43,23.67A23.35,23.35,0,0,0,16,28,17.81,17.81,0,0,0,21.92,41.7,20,20,0,0,1,9.43,35.18a21.11,21.11,0,0,1-2.14-3A25.63,25.63,0,0,1,4,22.35a2.28,2.28,0,0,0,0-.26H4s0-.09,0-.14a1,1,0,0,1,.25-.6A1,1,0,0,1,5,21h.11C7,21.08,12.32,21.43,16.43,23.67Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M4,21.94a1,1,0,0,1,.25-.6A1,1,0,0,1,5,21a1,1,0,0,0-.73.31A1,1,0,0,0,4,21.94Z"
      }), /*#__PURE__*/React.createElement("polygon", {
        points: "4 22.08 4 22.08 4 22.09 4 22.08"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M9.43,35.18A22.34,22.34,0,0,1,4,22.35,25.63,25.63,0,0,0,7.29,32.2,21.11,21.11,0,0,0,9.43,35.18Z"
      }));
    }
  }));
}
export default SvgIconSpa;